<template>
    <button
        type="button"
        data-interface-target="close-game-mobile-button"
        :aria-label="$tr('gameContainer.back')"
        :class="$style.bar"
        @click="emit('closeGame')"
    >
        <img
            :src="props.hideBranding ? ExitIcon : PlaygamaBackIcon"
            alt="exit"
            :class="[$style.icon, props.hideBranding && $style.icon_exit]"
        />
    </button>
</template>

<script lang="ts" setup>
import ExitIcon from './exit.svg'
import PlaygamaBackIcon from './playgama-back.svg'

const emit = defineEmits<{
    closeGame: []
}>()

const props = defineProps<{
    hideBranding?: boolean
}>()
</script>

<style module>
.bar {
    box-sizing: border-box;
    width: 32px;
    min-width: var(--pg-safe-area-left);
    height: 88px;
    padding: 16px 10px 8px;
    background-color: var(--purple-400);
    cursor: pointer;
}

.icon {
    display: block;
    width: 12px;
    height: 64px;
    margin-inline: auto;
}

.icon_exit {
    width: 8px;
    height: 40px;
}
</style>
